// レスポンス情報
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};



/* 共通APIエラーコード */
export const ErrorCode = {
  ERR_CODE_NONE: 0, //エラーなし

  ERR_CODE_USER_NO_USER: 1000, //指定したユーザーがいない
  ERR_CODE_USER_PASSWORD_NOMATCH: 1001,　//現パスワードが一致しない
  ERR_CODE_USER_NEN_PASSWORD_LENGTH: 1002, //新パスワード桁数異常
  ERR_CODE_USER_USER_ID_DUPLICATE: 1010, //重複エラー
  ERR_CODE_USER_PASSWORD_OLD: 1011,// //過去に使用したパスワードは使用できません
  ERR_CODE_USER_LOCK: 1012,  //ユーザロック中
  ERR_CODE_USER_PASSWORD_EXPIRATION: 1013, //ユーザロック中
  ERR_CODE_USER_MAILADRESS: 1014, //メールアドレスではありません
  ERR_CODE_USER_NOMAILADRESS: 1015, //メールアドレスが空です
  ERR_CODE_USER_LOGIN: 1016, //別ユーザが先にログイン中です

  //判定値設定画面
  ERR_CODE_JSET_FAIL_BEARING_FREQ: 2000,     //軸受特徴周波数設定リスト取得エラー
  ERR_CODE_JSET_NO_BEARING_FILE: 2001,  //軸受特徴周波数設定ファイルが存在しない
  ERR_CODE_JSET_NO_BEARING_INFO: 2002,  //軸受特徴周波数設定ファイルに軸受番号が存在しない
  ERR_CODE_JSET_FAIL_SIDEBAND_FREQ: 2050,     //側帯波周波数設定リスト取得エラー

  //判定値設定画面保存
  ERR_CODE_JSET_SAVE_FAIL: 2100,	//判定値設定画面保存エラー
  ERR_CODE_JSET_JDG_TYP_REQUIRED_ITEMS: 2101,	//診断タイプ:必須項目
  ERR_CODE_JSET_FREQ_C_INVALID_VALUE: 2102,	//周波数：不正値
  ERR_CODE_JSET_FREQ_C_CANNOT_BE_SET: 2103,	//周波数：設定不可
  ERR_CODE_JSET_FREQ_C_20TO6000: 2104,	//周波数：20～6000
  ERR_CODE_JSET_FREQ_C_1TO6000: 2105,	//周波数：1～6000
  ERR_CODE_JSET_FREQ_C_0_OR_HIGHER: 2106,	//周波数：0以上
  ERR_CODE_JSET_CLC_TYP_REQUIRED_ITEMS: 2107,	//演算方法：必須項目
  ERR_CODE_JSET_CLC_TYP_CANNOT_BE_SET: 2108,  //演算方法：入力範囲エラー
  ERR_CODE_JSET_TWRN_LIM_INVALIDVALUE: 2113,	//閾値_軽故障：不正値
  ERR_CODE_JSET_TWRN_LIM_0TO10000: 2114,	//閾値_軽故障：0～10000
  ERR_CODE_JSET_ALM_LIM_INVALID_VALUE: 2115,	//閾値_重故障：不正値
  ERR_CODE_JSET_ALM_LIM_0TO10000: 2116,	//閾値_重故障：0～10000
  ERR_CODE_JSET_BAND_VAL_INVALID_VALUE: 2117,	//裕度(%)：不正値
  ERR_CODE_JSET_BAND_VAL_CANNOT_BE_SET: 2118,	//裕度(%)：設定不可
  ERR_CODE_JSET_BAND_VAL_0TO10: 2119,	//裕度(%)：0～10
  ERR_CODE_JSET_BAND_VAL_0_OR_MORE: 2120,	//裕度(%)：0以上
  ERR_CODE_JSET_ADJ_ROT_ON_INCORRECT_VALUE: 2121,	//補正：回転数：不正値
  ERR_CODE_JSET_ADJ_ROT_ON_CANNOT_BE_SET: 2122,	//補正：回転数：設定不可
  ERR_CODE_JSET_ADJ_ROT_ON_VALID_OR_INVALID: 2123,	//補正：回転数：有効もしくは無効
  ERR_CODE_JSET_ALM_TYP_NO_REQUIRED_ITEM: 2124,	//異常種別:必須項目
  ERR_CODE_JSET_ALM_TYP_NO_CANNOT_BE_SET: 2125,	//異常種別：設定不可
  ERR_CODE_JSET_MOVE_AVERAGE_ADD_CHANGE: 2126,  //移動平均行の追加・変更に失敗
  ERR_CODE_JSET_MOVE_AVERAGE_RST: 2127, //移動平均行の初期化に失敗

  ERR_CODE_PLC_REQUEST_DUPLICATION: 2200,  //PLC手動指示リクエスト重複
  ERR_CODE_PLC_REQUEST_NO_DATA: 2201,       //該当れーこどがない

  //EMC情報画面
  ERR_CODE_EMC_DEVINDEX_DUPLICATE: 2300,     //デバイス重複
  ERR_CODE_EMC_NO_DATA: 2301,     //該当レコードがない

  //部分放電収集設定
  ERR_CODE_DEV_INDEX_DUPLICATION: 2900,     //機器番号・名称が重複
  ERR_CODE_NODATE: 2901,     //収集開始時刻が入力されていない
  ERR_CODE_NOLIML_VALUE: 2902,     //軽故障が入力されていない
  ERR_CODE_NOLIMH_VALUE: 2903,     //重故障が入力されていない
  ERR_CODE_LIM_VALUE: 2904,     //軽故障<重故障でない
  ERR_CODE_NOIPADR: 2905,     //IPアドレスが入力されていない
  ERR_CODE_IPADR_INCORRECT: 2906,     //IPアドレスの書式が不正
  ERR_CODE_NOLIMLPD_VALUE: 2907,  //PD強度閾値 軽故障が入力されていない
  ERR_CODE_NOLIMHPD_VALUE: 2908,  //PD強度閾値 重故障が入力されていない
  ERR_CODE_LIMPD_VALUE: 2909, //PD強度閾値 軽故障<重故障でない
  ERR_CODE_NOMCLC_TYP_ID_MAX: 2910,  //部分放電判定 最大値異常内容が登録されていない
  ERR_CODE_NOMCLC_TYP_ID_PD: 2911,  //部分放電判定 PD強度異常内容が登録されていない

  //絶縁劣化検出
  ERR_CODE_DATA_NONCATCH: 2950,  //DEV_INDEXの取得失敗かPLC_NOが存在しない

  //コナンエアー管理画面
  ERR_CODE_CONAN_CONANAIRSET_NODATA: 3000, //変更コナンエアーの登録がない
  ERR_CODE_CONAN_COLSET_NODATA: 3001, //変更コナンエアーに紐づくCOL_SETのアイテムがない
  ERR_CODE_CONAN_ITEM_HASDUPULICATES: 3002, //機器番号の重複
  ERR_CODE_CONAN_DEVINDEX_IOT_REGISTERED: 3003, //BOX管理側と機器番号の重複
  //データ収集画面
  ERR_CODE_RUNFLG_CHECK_ERROR: 3100, //TMBEE-BOXとコナンエアのRUN_FLGが両方ともON
  ERR_CODE_SYSTEM_ERROR: -99999, //システム異常


}
